<template>
  <div class="comp-md-setting-menu-card">
    <div class="card-header">
      <span class="card-header-left">
        {{fieldMetas.title}}
      </span>
      <span class="card-header-right">
        <i v-show="fieldIndex !== 0" class="icon iconfont icon-up card-header-icon" @click="handelIconButton('up')"></i>
        <i v-show="fieldIndex !== fieldLength - 1" class="icon iconfont icon-down card-header-icon" @click="handelIconButton('down')"></i>
        <i class="icon iconfont icon-garbage-active card-header-icon" @click="handelIconButton('delete')"></i>
      </span>
    </div>
    <DataForm ref="dataForm" :index='fieldIndex' :fieldMetas="fieldMetas.metas" :value="fieldMetas.value"></DataForm>
    <slot name="third"/>
  </div>
</template>

<script>
import DataForm from '@inv/components/metaData/form/view/data-form';

export default {
  props: {
    fieldMetas: kr.vue.getPropObject(),
    fieldIndex: kr.vue.getPropNumber(),
    fieldLength: kr.vue.getPropNumber(),
    parentIndx: kr.vue.getPropString(),
    ancestorIndx: kr.vue.getPropNumber(),
  },
  components: {
    DataForm
  },
  methods: {
    handelIconButton(type) {
      this.$emit('handelButton', type, this.fieldMetas, this.parentIndx, this.ancestorIndx);
    },
    getForm() {
      const { dataForm } = this.$refs;
      return dataForm.getForm();
    },
    async submit() {
      const { dataForm } = this.$refs;
      return await dataForm.submit();
    }
  }
}
</script>

<style lang="scss">

  .comp-md-setting-menu-card {
    background-color: #fff;
    padding: 12px;
    margin-bottom: 12px;

    .card-header {
      height: 21px;
      margin-bottom: 11px;

      .card-header-left {
        font-size: 14px;
        color: #9094a3;
        text-align: left;
        line-height: 21px;
      }

      .card-header-right {
        float: right;
        line-height: 21px;

        .card-header-icon {
          cursor: pointer;
          color: #9094a3;
          font-size: 14px;
          margin-left: 8px;
        }
      }
    }
  }

</style>
